<svelte:options accessors/>
<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import Snackbar, {Label} from "@smui/snackbar";
    import {Actions} from "@smui/dialog";
    import IconButton from "@smui/icon-button";

    export let data = {};
    export let cities: Array<any> = [];
    export let hours: any = {
        hours: [],
        loading: false,
        queried: false
    };
    export let selected: any;
    export let selectedHour: any;
    export let point: any;
    let snackbarCmpt;
    let date: any;
    export let value: any;
    let editable: boolean = true
    const dispatch = createEventDispatcher();

    function queryData() {
        if (validQuery()) {
            hours = {
                loading: true
            }
            dispatch('queryHours', {
                'fecha': date,
                'puntoServicio': point.code
            })
        }
    }

    function validQuery() {
        return !!selected && !!point && !!date;
    }

    export function valid() {
        return !!date && !!selectedHour && !!point && !!selected
    }

    function accept() {
        if (valid()) {
            value = {
                fechaHora: date + ' ' + selectedHour,
                puntoServicio: point.code,
                ciudad: selected.id
            }
            editable = false;
            snackbarCmpt?.open();
        } else {
            value = undefined;
            alert('cita no valida');
        }
    }

    function cancel() {
        selected = undefined;
        selectedHour = undefined;
        point = undefined;
        date = undefined;
        hours = {
            hours: [],
            loading: false,
            queried: false
        }
        editable = true;
        value = null;
    }
</script>
<section class="pb-15">
    <div class="container max-w-900px mx-auto">
        <strong class="block mb-1">Cita en taller autorizado Nissan</strong>
        <div class="naui-field">
            <select class="naui-input mb-1"
                    disabled={!editable}
                    bind:value={selected}>
                <option hidden value={undefined}>Ciudad</option>
                {#each cities as city}
                    <option value={city}>{city.name}</option>
                {/each}
            </select>
            <span></span>
        </div>
        <div class="naui-field">
            <select class="naui-input mb-15" bind:value={point} disabled={!editable}>
                <option selected hidden value={undefined}>Selecciona un taller</option>
                {#if selected && selected.points}
                    {#each selected.points as point}
                        <option value={point}>{point.description}</option>
                    {/each}
                {/if}
            </select>
            <span></span>
        </div>
        <strong class="block mb-1 text-gray">Selecciona fecha y hora para tu cita</strong>
        <div class="naui-field mb-1">
            <input type="date" class="naui-input" bind:value={date} disabled={!editable}>
        </div>
        {#if !hours?.queried}
            <div class="box mt-15">
                <div class="btn accent" on:click={()=>queryData()}>CONSULTAR HORAS DISPONIBLES</div>
            </div>
        {/if}
        {#if hours.loading}
            Consultando horas disponibles...
        {:else if !!hours?.queried}
            {#if hours.hours.length > 0}
                <div class="naui-field">
                    <select class="naui-input" bind:value={selectedHour} disabled={!editable}>
                        <option selected hidden value={null}>Selecciona la hora</option>
                        {#each hours.hours as h}
                            <option value={h.hora}>{h.hora}</option>
                        {/each}
                    </select>
                    <span></span>
                </div>
                {#if value}
                    <div class="box mt-15 sx-ii">
                        <div class="btn button-secondary" on:click={()=>cancel()}>Modificar cita</div>
                    </div>
                {:else}
                    <div class="box mt-15 sx-ii">
                        <div class="btn accent" on:click={()=>accept()}>Aceptar</div>
                        <div class="btn accent" on:click={()=>cancel()}>Cancelar</div>
                    </div>
                {/if}
            {:else}
                <strong>No hay citas disponibles</strong>
                <div class="box mt-15 sx-ii">
                    <div class="btn accent" on:click={()=>cancel()}>Cancelar</div>
                </div>
            {/if}
        {:else}
        {/if}
    </div>
</section>

<Snackbar bind:this={snackbarCmpt}>
    <Label>Estimado cliente: El valor de la mano de obra cambiará de acuerdo al lugar donde agendará su cita.</Label>
    <Actions>
        <IconButton class="material-icons" title="Dismiss" on:click={()=>snackbarCmpt.close()}>close</IconButton>
    </Actions>
</Snackbar>